import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Navigate } from "react-router-dom"
import { loginSuccessful } from "../actions" 

const HandleLogin = () => {
    const dispatch = useDispatch()
    let local_access_token = localStorage.getItem("access_token")
    const [access_token, setAccessToken] = useState(local_access_token)
    useEffect(() => {
        if (!(local_access_token === undefined || local_access_token === null || local_access_token === "null")) {
            return
        } else {
            const at = getAccessTokenFromUrl()
            if (at !== null && at !== "null" && at !== "") {
                setAccessToken(at)
                localStorage.setItem("access_token", at)
                dispatch(loginSuccessful())
            }
        }
    }, [dispatch, access_token, local_access_token])
    return <div>{!(access_token === undefined || access_token === null || access_token === "null")?<Navigate to="/" replace={true}/>:null}</div>
}


const getAccessTokenFromUrl = () => {
    var pageUrl = window.location.href;
    pageUrl = pageUrl.toString()

    var paramIndex = pageUrl.indexOf("#")
    if (paramIndex === -1) {
        return null
    }
    var parameters = pageUrl.substring(paramIndex + 1)
    // console.log("parameters: ", parameters)
    var accessToken = getParameter(parameters, "access_token=")
    return accessToken
}

const getParameter = (url, param) => {
    var urlVars = url.split('&')
    var returnValue;
    for (var i = 0; i < urlVars.length; i++) {
        var urlParam = urlVars[i]
        var index = urlParam.toString().indexOf("=")
        urlParam = urlParam.substring(0, index + 1)
        if (param === urlParam) {
            returnValue = urlVars[i].replace(param, "")
            i = urlVars.length
        }
    }
    return returnValue
}

export default HandleLogin